import { makeVar } from '@apollo/client';

export const snackBarAlerts = makeVar([]);

export const nationalTaxServiceCredentialsDialogVar = makeVar({
  open: false,
  autocomplete: false,
  showTerms: true,
});
